import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ListPopup from "../../PagesComponents/Dashboard/ListPopup/ListPopup";
import { RequestSearchGroupSubmissions } from "../../../store/actions/dashboardActions";
import { isTaskAwaitingReports } from "./constants";

import "./styles.scss";

// Opens the same related-reports popup as the report page's "View Related":
// one row per vm / network / type of the submission, a row opens its report.
const SandboxTaskReportsButton = ({ task }) => {
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const loading = useSelector((state) => state.dashboard.groupSubmissionsLoading);

  if (task?.status !== "Completed" || !task.reportFileID) return null;

  if (isTaskAwaitingReports(task)) {
    return (
      <span
        className="sandbox-task-reports sandbox-task-reports--pending"
        title="The report list appears when the analysis completes.">
        Analyzing…
      </span>
    );
  }

  const openHandler = () => {
    dispatch(RequestSearchGroupSubmissions(task.reportFileID));
    setShowPopup(true);
  };

  return (
    <>
      <button
        type="button"
        className="sandbox-task-reports"
        disabled={loading}
        onClick={openHandler}>
        {showPopup && loading ? "Loading…" : "View reports"}
      </button>
      {/* CustomTable reads groupSubmissions only when it mounts, so mount the
          popup once this group's rows have arrived. */}
      {showPopup && !loading ? (
        <ListPopup
          show={showPopup}
          setShow={setShowPopup}
          tableType="analysisReportsPopup"
          tableType2="analysisReportsPopup"
        />
      ) : null}
    </>
  );
};

export default SandboxTaskReportsButton;
